import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';

import { Factory, FactoryService } from '@app/core/factories';

@Component({
  selector: 'filter-factory',
  templateUrl: './filter-factory.component.html',
  styleUrls: ['./filter-factory.component.scss'],
})
export class FilterFactoryComponent implements OnInit {
  @Input() value :number[] | number;
  @Input() label :string = 'Factory';
  @Output() changeFactory :EventEmitter<number[] | number> = new EventEmitter<
    number[] | number
  >();
  @Input() options :{ multi :boolean } = { multi: false };

  factories$ :Observable<Factory[]>;

  constructor(private factoryService :FactoryService) {}

  ngOnInit() :void {
    this.getDataFromService();
  }

  onChange() {
    this.changeFactory.emit(this.value);
  }

  trackClientByFn(item :any) {
    return item.id;
  }

  private getDataFromService() :void {
    this.factories$ = this.factoryService.factory$;
  }
}
